import { FC } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";
import { useCommands } from "./useCommands";

export const TransactionBulkCustomerCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { returnToRoot } = useCommands();
    const {
        selectedTransactionCount = 0,
        transactionBulkCustomerOptions = [],
    } = options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set billable customer for ${pluralizeWithCount("transaction", selectedTransactionCount)}`}
            options={transactionBulkCustomerOptions}
            onOptionSelected={returnToRoot}
        />
    );
};
